import "./speech.f14ceeb8.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $f1q41 = parcelRequire("f1q41");

var $bj515 = parcelRequire("bj515");

var $f1q41 = parcelRequire("f1q41");
const $9ba039a6c6824784$var$separateCommands = (transcript)=>{
    // sometimes see numbers show up as digits; separate them since we can assume the commands are only single numbers/digits
    const commands = transcript.toLowerCase().split(/\s+|(\d)(\d)/);
    return (0, $f1q41.compact)(commands);
};
const $9ba039a6c6824784$export$7a6092e2ae7e1845 = (result)=>{
    // Since `continuous = true`, past results will be included. Just use the most recent one.
    // https://developer.mozilla.org/en-US/docs/Web/API/SpeechRecognitionResultList
    const lastResult = result[result.length - 1];
    // since `maxAlternatives = 1`, we only need the first result
    const lastTranscript = lastResult[0].transcript;
    return $9ba039a6c6824784$var$separateCommands(lastTranscript);
};


// https://developer.mozilla.org/en-US/docs/Web/API/Web_Speech_API/Using_the_Web_Speech_API#chrome_support
const $3438e659a18d2607$var$iSpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
const $3438e659a18d2607$var$createRecognizer = ()=>{
    const recognition = new $3438e659a18d2607$var$iSpeechRecognition();
    recognition.continuous = true;
    recognition.lang = "en-US";
    recognition.interimResults = false;
    recognition.maxAlternatives = 1;
    return recognition;
};
class $3438e659a18d2607$export$2e2bcd8739ae039 {
    constructor(){
        this.autoRestart = true;
        // callback
        this.onError = (event)=>{
            // https://developer.mozilla.org/en-US/docs/Web/API/SpeechRecognitionErrorEvent/error#value
            switch(event.error){
                case "not-allowed":
                case "service-not-allowed":
                    console.error("Access not allowed; please restart.");
                    this.autoRestart = false;
                    break;
                case "network":
                    console.error("Offline; network connection required for speech recognition");
                    break;
                case "no-speech":
                    break;
                default:
                    console.error("Unexpected error in speech recognition:");
                    console.error(event.error);
            }
        };
        // callback
        this.onEnd = ()=>{
            setTimeout(()=>{
                if (this.autoRestart) {
                    console.log("restarting speech recognition");
                    this.start();
                }
            }, 100);
        };
        this.commands = (0, $bj515.allCommands)();
        this.recognition = $3438e659a18d2607$var$createRecognizer();
        this.setupListeners();
    }
    setupListeners() {
        this.recognition.addEventListener("nomatch", ()=>{
            console.log("no match for voice command");
        });
        // ensure it runs continuously
        // https://stackoverflow.com/questions/29996350/speech-recognition-run-continuously
        this.recognition.addEventListener("error", this.onError);
        // only restart once
        const endCallback = (0, $f1q41.throttle)(this.onEnd, 100, {
            leading: true,
            trailing: false
        });
        // https://developer.mozilla.org/en-US/docs/Web/API/SpeechRecognition#events
        for (const event of [
            "audioend",
            "end",
            "soundend",
            "speechend"
        ])this.recognition.addEventListener(event, endCallback);
    }
    /**
   * register event handler
   */ onCommand(callback) {
        this.recognition.addEventListener("result", (event)=>{
            // TODO only do this once
            const commands = (0, $9ba039a6c6824784$export$7a6092e2ae7e1845)(event.results);
            for (const command of commands)if (this.commands.includes(command)) callback(command);
            else console.warn("unknown command:", command);
        });
    }
    start() {
        this.autoRestart = true;
        try {
            this.recognition.start();
        } catch (DomException) {
        // already started; safe to ignore
        }
    }
    stop() {
        this.autoRestart = false;
        this.recognition.stop();
    }
}


const $09c69d38358ea0fe$var$run = async ()=>{
    const listener = new (0, $3438e659a18d2607$export$2e2bcd8739ae039)();
    listener.onCommand((result)=>window.parent.postMessage(result, "*"));
    window.addEventListener("message", (event)=>{
        switch(event.data){
            case "start":
                listener.start();
                break;
            case "stop":
                listener.stop();
                break;
            default:
                console.error("Unknown message", event.data);
        }
    });
};
$09c69d38358ea0fe$var$run();


//# sourceMappingURL=speech.fe546b8c.js.map
